/* hcx-size-finder : selecteur de taille guide sur les pages collection.
 *
 * Traduit un tour de poitrail en tranche de 5 cm et applique la facette native
 * Shopify. Le filtrage reste SERVEUR : la section de grille pagine
 * (`{% paginate %}`, 48 par page sur 59), un filtrage JavaScript ne verrait
 * jamais la totalite du catalogue.
 *
 * Le badge, lui, est client : il calcule la taille a commander depuis la
 * grille du produit courant, parce qu'une meme lettre ne veut pas dire la meme
 * chose d'un modele a l'autre (M commence entre 35 et 77 cm selon le harnais).
 *
 * Les libelles de tranche doivent correspondre EXACTEMENT aux valeurs indexees
 * par Shopify, accent compris. Source : _Scripts/hcx_size_buckets.py
 *
 * Spec : Niches/wildone/SPEC-filtre-taille-collections-2026-09-08.md
 */
(function () {
  'use strict';

  var STEP = 5, FLOOR = 20, CEIL = 95;
  var PARAM = 'filter.p.m.custom.chest_size_range';
  var GAUGE_PARAM = 'filter.p.m.custom.dog_size';
  var STORE_KEY = 'hcx_dog_chest';
  var MIN_CM = 20, MAX_CM = 130;

  /* ---- Tranches et memoire --------------------------------------------- */

  function bucketFor(cm) {
    if (!(cm >= MIN_CM && cm <= MAX_CM)) return null;
    if (cm >= CEIL) return CEIL + ' cm et plus';
    var a = Math.floor((cm - FLOOR) / STEP) * STEP + FLOOR;
    if (a < FLOOR) a = FLOOR;
    return a + ' à ' + (a + STEP) + ' cm';
  }

  function readMeasure() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      return (v && v.cm >= MIN_CM && v.cm <= MAX_CM) ? v.cm : null;
    } catch (e) {
      return null; // navigation privee : on continue sans memoire
    }
  }

  function saveMeasure(cm) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ cm: cm, at: Date.now() })); }
    catch (e) { /* sans effet */ }
  }

  function clearMeasure() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) { /* sans effet */ }
  }

  function applyMeasure(cm) {
    var bucket = bucketFor(cm);
    if (!bucket) return false;
    saveMeasure(cm);
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    url.searchParams.delete(GAUGE_PARAM);
    url.searchParams.append(PARAM, bucket);
    url.searchParams.delete('page');
    window.location.href = url.toString();
    return true;
  }

  function activeBuckets() {
    return new URL(window.location.href).searchParams.getAll(PARAM);
  }

  function gaugeActive() {
    return new URL(window.location.href).searchParams.getAll(GAUGE_PARAM).length > 0;
  }

  /* Un filtre poitrail present dans l'URL est la verite du catalogue servi
   * par Shopify. La mesure memorisee ne peut l'enrichir (afficher/calculer
   * un centimetre exact plutot que la tranche, prereplir un champ, poser un
   * badge, tagger un lien ?taille=) que si elle retombe pile sur l'unique
   * tranche active ; sinon elle vient d'un autre produit ou d'une autre
   * session et doit etre ignoree plutot que de fabriquer une fausse
   * precision ou d'afficher une contradiction. */
  function trustedCm(cm, active) {
    if (!cm || active.length !== 1) return null;
    return bucketFor(cm) === active[0] ? cm : null;
  }

  /* ---- Saisie ----------------------------------------------------------- */

  function bindWidget(root) {
    var input = root.querySelector('[data-hcx-sf-input]');
    var submit = root.querySelector('[data-hcx-sf-submit]');
    var error = root.querySelector('[data-hcx-sf-error]');
    if (!input || !submit) return;

    // Si un filtre poitrail est actif et contredit la mesure memorisee, ne
    // pas la preremplir : ce serait afficher comme "confirmee" une valeur
    // qui ne correspond pas a ce que la page montre reellement.
    var widgetActive = activeBuckets();
    var saved = widgetActive.length ? trustedCm(readMeasure(), widgetActive) : readMeasure();
    if (saved) input.value = saved;

    function go() {
      var cm = parseInt(input.value, 10);
      if (!applyMeasure(cm)) {
        if (error) error.classList.add('is-shown');
        input.focus();
      }
    }

    submit.addEventListener('click', go);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
    input.addEventListener('input', function () {
      if (error) error.classList.remove('is-shown');
    });

    bindToggle(root);
    bindStepper(root);
    bindMeasure(root);
    bindGauge(root);
    mountRow(root);
  }

  /* ---- Mobile : le declencheur rejoint la rangee du bouton « Filtres » ----
   * Les deux boutons vivent dans deux sections Shopify differentes (l'aside
   * des filtres, la section de la grille) : pas d'ancetre commun avant <main>,
   * donc pas de solution CSS. On deplace le noeud -- les ecouteurs deja poses
   * le suivent. Idempotent, et sans effet si le bouton Filtres n'existe pas
   * (collection sans facette : le declencheur reste alors a sa place). */

  function mountRow(root) {
    // Le bouton nait `hidden` (liquid) : il ne doit devenir visible qu'une
    // fois sa position finale decidee, jamais avant -- sinon il flashe dans
    // sa position d'origine puis le contenu qui suit saute quand on l'en
    // retire (signale par Raji 2026-09-15). Chaque `return` ci-dessous est
    // donc precede de la decision "ou le bouton doit-il vivre ?", jamais
    // l'inverse.
    var toggle = root.querySelector('[data-hcx-sf-toggle]');

    if (!window.matchMedia('(max-width: 749px)').matches) {
      // PC : `.hcx-sf__toggle { display: none }` le masque de toute facon,
      // mais on leve `hidden` pour qu'un redimensionnement de fenetre vers
      // le mobile (sans rechargement) le laisse utilisable a sa place.
      if (toggle) toggle.hidden = false;
      return;
    }
    if (document.querySelector('.hcx-sf-row')) return; // deja monte
    var filters = document.querySelector('.cf-mobile-toggle');
    // La section des filtres est une AUTRE section Shopify : rien ne garantit
    // qu'elle soit rendue quand celle-ci s'amorce. Si le bouton manque encore,
    // on retente une fois au chargement complet plutot que d'abandonner.
    if (!filters && !mountRow.retried) {
      mountRow.retried = true;
      window.addEventListener('load', function () { mountRow(root); });
      return;
    }
    if (!toggle || !filters || !filters.parentNode) {
      // Pas de bouton Filtres sur cette collection : le declencheur reste
      // seul, a sa position d'origine, mais doit tout de meme se reveler.
      if (toggle) toggle.hidden = false;
      return;
    }

    var row = document.createElement('div');
    row.className = 'hcx-sf-row';
    filters.parentNode.insertBefore(row, filters);
    row.appendChild(filters);
    row.appendChild(toggle);
    toggle.hidden = false;

    // Cote a cote, le libelle long passe sur deux lignes : on bascule sur le
    // libelle court porte par le balisage (data-hcx-sf-short).
    var title = toggle.querySelector('[data-hcx-sf-short]');
    if (title) title.textContent = title.getAttribute('data-hcx-sf-short');

    // La boite d'origine ne peint plus rien dans le flux : elle ne sert plus
    // qu'a porter la feuille et son voile (tous deux en position:fixed).
    root.classList.add('hcx-sf--moved');
  }

  /* ---- Stepper − / + ----------------------------------------------------
   * On garde le centimetre EXACT : c'est lui qui fait vivre trustedCm(), le
   * badge par produit et le ?taille= sur la fiche. Le stepper ne fait qu'eviter
   * le pave numerique sur mobile ; le champ reste saisissable a la main. */

  function bindStepper(root) {
    var input = root.querySelector('[data-hcx-sf-input]');
    var steps = root.querySelectorAll('[data-hcx-sf-step]');
    if (!input || !steps.length) return;

    var lo = parseInt(input.getAttribute('min'), 10) || MIN_CM;
    var hi = parseInt(input.getAttribute('max'), 10) || MAX_CM;
    var seed = parseInt(input.getAttribute('placeholder'), 10) || 42;

    function bump(delta) {
      var cur = parseInt(input.value, 10);
      // Champ vide : le premier appui pose la valeur de depart plutot que NaN.
      cur = isNaN(cur) ? seed : cur + delta;
      if (cur < lo) cur = lo;
      if (cur > hi) cur = hi;
      input.value = cur;
      // Meme effet qu'une frappe : efface le message d'erreur s'il etait la.
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    for (var i = 0; i < steps.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          bump(parseInt(btn.getAttribute('data-hcx-sf-step'), 10) || 0);
        });
      })(steps[i]);
    }
  }

  /* Les visuels des 3 etapes ne sont telecharges qu'a la premiere ouverture du
   * panneau qui les contient : zero octet pour qui ne l'ouvre jamais.
   * `loading="lazy"` ne suffirait pas -- sur un element ne dans un conteneur
   * `hidden`, le navigateur diffère le chargement et ne le reprend jamais. */
  function revealStepImages(scope) {
    var imgs = scope.querySelectorAll('[data-hcx-sf-step-src]');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].getAttribute('src')) {
        imgs[i].setAttribute('src', imgs[i].getAttribute('data-hcx-sf-step-src'));
      }
    }
  }

  /* ---- Mobile : le rectangle ouvre une feuille par-dessus la page --------
   * Avant : le corps se depliait SUR PLACE et poussait la grille vers le bas,
   * donc mangeait la zone de flottaison au moment meme ou le client cherche
   * des produits. Depuis le 2026-09-14 il sort du flux (position:fixed, cf. la
   * media query mobile du CSS) : la grille ne bouge plus, ouvert ou ferme.
   * Sur PC rien ne change, le corps y est affiche en permanence. */

  function bindToggle(root) {
    var toggle = root.querySelector('[data-hcx-sf-toggle]');
    if (!toggle) return;
    var closeBtn = root.querySelector('[data-hcx-sf-sheet-close]');
    var mobile = window.matchMedia('(max-width: 749px)');
    var pushed = false;

    function isOpen() { return root.classList.contains('is-open'); }

    function setOpen(on) {
      root.classList.toggle('is-open', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      // La feuille est en position:fixed : sans ce verrou, le doigt fait
      // defiler la grille derriere elle.
      document.documentElement.style.overflow = (on && mobile.matches) ? 'hidden' : '';
      if (on) revealStepImages(root);
    }

    function open() {
      if (isOpen()) return;
      setOpen(true);
      // Une entree d'historique pour que le bouton retour du telephone ferme
      // la feuille au lieu de quitter la collection.
      try { history.pushState({ hcxSheet: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    }

    function shut() { setOpen(false); }

    function close() {
      if (!isOpen()) return;
      if (pushed) { pushed = false; history.back(); return; } // popstate fera le reste
      shut();
    }

    toggle.addEventListener('click', function () {
      // Volontairement AUCUN focus sur le champ : sur mobile il ferait surgir
      // le clavier par-dessus le contenu que le client vient d'ouvrir pour le
      // lire. Il clique dans le champ quand il l'a decide.
      if (isOpen()) close(); else open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    // Le voile est le ::before de la racine : un clic dessus a pour cible la
    // racine elle-meme, jamais un enfant.
    root.addEventListener('click', function (e) { if (e.target === root) close(); });

    window.addEventListener('popstate', function () {
      if (isOpen()) { pushed = false; shut(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Bascule vers le PC alors que la feuille est ouverte : le corps y est
    // affiche normalement, il ne doit rester ni voile ni verrou de defilement.
    var onChange = function () { if (!mobile.matches && isOpen()) shut(); };
    if (mobile.addEventListener) mobile.addEventListener('change', onChange);
    else if (mobile.addListener) mobile.addListener(onChange);
  }

  /* ---- « Comment mesurer » : fenetre sur PC, depliage sur mobile -------- */

  function bindMeasure(scope) {
    var trigger = scope.querySelector('[data-hcx-sf-measure]');
    var panel = document.querySelector('[data-hcx-sf-measure-panel]');
    if (!trigger || !panel) return;

    // Le finder est rendu dans .ptq-section, qui porte un reset
    // `.ptq-section-wrapper .ptq-section * { margin:0; padding:0 }` : il ecrasait
    // toute la mise en page interne de la fenetre. On la sort sur <body>
    // (elle est en position:fixed, la position DOM n'a aucune importance).
    if (panel.parentNode !== document.body) document.body.appendChild(panel);

    if (panel.dataset.hcxBound === '1') { bindTrigger(); return; }
    panel.dataset.hcxBound = '1';

    var pushed = false;

    // L'etape 3 dessinee ("43 cm" + fleche, "Tapez le chiffre ci-dessous")
    // pointait vers rien : le vrai champ restait dans le bandeau, derriere la
    // modale (bug signale par Raji 2026-09-15). On deplace le NOEUD reel
    // (controls + message d'erreur) dans la fenetre a l'ouverture plutot que
    // d'en dupliquer un : meme input, memes ecouteurs (stepper, submit,
    // validation) deja lies par bindWidget/bindStepper -- zero synchronisation
    // a ecrire. On le remet exactement a sa place a la fermeture.
    var controls = scope.querySelector('.hcx-sf__controls');
    var errorEl = scope.querySelector('.hcx-sf__error');
    var controlsHome = controls ? controls.parentNode : null;
    var controlsNext = controls ? controls.nextSibling : null;
    var errorHome = errorEl ? errorEl.parentNode : null;
    var errorNext = errorEl ? errorEl.nextSibling : null;
    var note = panel.querySelector('.hcx-sf-measure__note');

    function open() {
      // Les visuels des 3 etapes, comme dans la feuille mobile. (Avant le
      // 2026-09-14 la fenetre portait une seule grande image sous
      // data-hcx-sf-src ; elle a ete remplacee par les 3 etapes partagees.)
      revealStepImages(panel);
      if (controls && note) panel.querySelector('.hcx-sf-measure__inner').insertBefore(controls, note);
      if (errorEl && note) panel.querySelector('.hcx-sf-measure__inner').insertBefore(errorEl, note);
      panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      // Une entree d'historique pour que le bouton retour du telephone ferme
      // la fenetre au lieu de quitter la page.
      try { history.pushState({ hcxMeasure: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
      var closeBtn = panel.querySelector('[data-hcx-sf-measure-close]');
      if (closeBtn) closeBtn.focus();
    }

    function shut() {
      panel.hidden = true;
      document.documentElement.style.overflow = '';
      if (controls && controlsHome) controlsHome.insertBefore(controls, controlsNext);
      if (errorEl && errorHome) errorHome.insertBefore(errorEl, errorNext);
    }

    function close() {
      if (panel.hidden) return;
      if (pushed) { pushed = false; history.back(); return; } // popstate fera le reste
      shut();
    }

    window.addEventListener('popstate', function () {
      if (!panel.hidden) { pushed = false; shut(); }
    });

    panel.addEventListener('click', function (e) {
      if (e.target === panel || e.target.closest('[data-hcx-sf-measure-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });

    function bindTrigger() {
      trigger.addEventListener('click', function () {
        if (panel.hidden) open(); else close();
      });
    }
    bindTrigger();
  }

  /* ---- Porte de sortie par gabarit -------------------------------------- */

  /* Il y a DEUX exemplaires du declencheur depuis le 2026-09-14 : celui de
   * l'en-tete (PC) et celui du corps (mobile, l'en-tete y est masque car il
   * resterait sous le voile de la feuille). On les lie tous, pas seulement le
   * premier -- c'est exactement le piege signale dans le CSS a l'epoque ou le
   * balisage n'en portait qu'un. */
  function bindGauge(scope) {
    var triggers = scope.querySelectorAll('[data-hcx-sf-nogauge]');
    var gauge = scope.querySelector('[data-hcx-sf-gauge]');
    if (!triggers.length) return;
    if (!gauge) {
      // Collection sans facette gabarit : on retire le lien plutot que de
      // laisser une promesse qu'on ne peut pas tenir.
      for (var h = 0; h < triggers.length; h++) triggers[h].hidden = true;
      return;
    }
    var main = scope.querySelector('.hcx-sf__main');
    var back = gauge.querySelector('[data-hcx-sf-gauge-back]');

    function show(on) {
      gauge.hidden = !on;
      if (main) main.hidden = on;
      for (var k = 0; k < triggers.length; k++) triggers[k].hidden = on;
    }
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function () { show(true); });
    }
    if (back) back.addEventListener('click', function () { show(false); });
  }

  /* ---- Badge de taille --------------------------------------------------- */

  /* Certaines etiquettes portent deja le mot taille (« Taille unique ») :
   * prefixer aveuglement donnerait « Taille Taille unique ». */
  function labelize(picked) {
    var joined = picked.length > 1 ? picked[0] + ' ou ' + picked[1] : picked[0];
    return /^taille/i.test(joined) ? joined : 'Taille ' + joined;
  }

  /* Parmi les tailles dont la plage contient la mesure, celle ou la mesure est
   * la mieux CENTREE. Toujours une seule reponse : le client ne doit jamais
   * avoir a trancher lui-meme. En cas de quasi-egalite (moins de 0,15 d'ecart
   * de centrage), on retient la taille AU-DESSUS -- la meme regle deja
   * affichee ailleurs sur la fiche produit quand aucun calculateur n'est
   * disponible ("Entre deux tailles ? Choisissez generalement la taille
   * au-dessus, sauf indication contraire sur la grille du modele"). */
  function pickSizes(sizes, cm) {
    var matches = [];
    for (var i = 0; i < sizes.length; i++) {
      var lo = sizes[i][1], hi = sizes[i][2];
      if (cm >= lo && cm <= hi) {
        var span = (hi - lo) || 1;
        matches.push({ label: sizes[i][0], lo: lo, hi: hi, score: Math.abs(cm - (lo + hi) / 2) / span });
      }
    }
    if (!matches.length) return null;
    matches.sort(function (a, b) { return a.score - b.score; });
    if (matches.length > 1 && (matches[1].score - matches[0].score) < 0.15) {
      var a = matches[0], b = matches[1];
      return [b.lo > a.lo ? b.label : a.label];
    }
    return [matches[0].label];
  }

  function paintBadges() {
    if (gaugeActive()) return 0; // gabarit : pas de mesure exacte, pas de badge
    var active = activeBuckets();
    if (!active.length) return 0;
    var cm = trustedCm(readMeasure(), active);
    if (!cm) return 0; // filtre actif mais mesure absente/perimee : pas de fausse precision, pas de ?taille=

    var removed = 0;
    var cards = document.querySelectorAll('.ptq-card[data-hcx-sizes]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.hcx-sf-badge')) continue;

      var sizes;
      try { sizes = JSON.parse(card.getAttribute('data-hcx-sizes')); } catch (e) { continue; }
      var picked = pickSizes(sizes, cm);

      if (!picked) {
        // La tranche de 5 cm laisse passer quelques produits qui ne couvrent
        // pas le centimetre exact. Seconde ligne de defense : on les retire.
        card.hidden = true;
        removed++;
        continue;
      }

      var badge = document.createElement('span');
      badge.className = 'hcx-sf-badge';
      badge.textContent = labelize(picked);
      (card.querySelector('.ptq-image-wrapper') || card).appendChild(badge);

      // Une seule taille trouvee, et c'est un vrai code (XS..2XL, pas
      // « Taille unique ») : on la passe a la fiche produit (?taille=M) pour
      // qu'elle s'y selectionne toute seule (lu par snippets/c4-pdp-story).
      if (picked.length === 1 && /^[A-Za-z0-9]{1,4}$/.test(picked[0])) {
        var links = card.querySelectorAll('a[href*="/products/"]');
        for (var j = 0; j < links.length; j++) {
          var href = links[j].getAttribute('href');
          if (!href || /[?&]taille=/.test(href)) continue;
          links[j].setAttribute(
            'href',
            href + (href.indexOf('?') === -1 ? '?' : '&') + 'taille=' + encodeURIComponent(picked[0])
          );
        }
      }
    }
    return removed;
  }

  /* ---- Popup "un mot sur les tailles" ------------------------------------
   * Montree UNE SEULE FOIS par client (localStorage), a la toute premiere
   * fois que des badges sont reellement peints. Objectif (Raji 2026-09-15) :
   * un client avec un grand chien tombant sur un badge "XS"/"S" selon le
   * modele ne doit pas s'inquieter -- la lettre varie d'un fabricant a
   * l'autre, le badge correspond bien a SON chien sur CE harnais.
   */

  var SIZENOTE_KEY = 'hcx_sizenote_seen';

  function sizeNoteSeen() {
    try { return localStorage.getItem(SIZENOTE_KEY) === '1'; }
    catch (e) { return true; } // navigation privee : ne jamais insister
  }

  function maybeShowSizeNote(badgeCount) {
    if (!badgeCount || sizeNoteSeen()) return;
    var panel = document.querySelector('[data-hcx-sf-sizenote-panel]');
    if (!panel) return;

    // Meme raison que la fenetre "Comment mesurer" : le reset
    // `.ptq-section-wrapper .ptq-section * { margin:0; padding:0 }` casserait
    // sa mise en page si elle restait dans .ptq-section.
    if (panel.parentNode !== document.body) document.body.appendChild(panel);

    try { localStorage.setItem(SIZENOTE_KEY, '1'); } catch (e) { /* sans effet */ }

    function close() { panel.hidden = true; }

    panel.addEventListener('click', function (e) {
      if (e.target === panel || e.target.closest('[data-hcx-sf-sizenote-close]')) close();
    });
    var ok = panel.querySelector('[data-hcx-sf-sizenote-ok]');
    if (ok) ok.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });

    panel.hidden = false;
  }

  /* Rappel d'usage sous la ligne de filtre : la taille trouvee est reportee
   * sur la fiche produit au clic (cf. ?taille= plus haut). Remplace l'ancienne
   * note « X modeles retires » (demande Raji 2026-09-10). */
  function noteRemoved() {
    if (gaugeActive()) return;
    var active = activeBuckets();
    if (!active.length || !trustedCm(readMeasure(), active)) return;
    var text = document.querySelector('[data-hcx-sf-banner-text]');
    if (!text || text.querySelector('.hcx-sf-banner__hint')) return;
    text.innerHTML += ' <span class="hcx-sf-banner__hint">Cliquez sur un harnais : '
      + '<b>sa taille est déjà sélectionnée</b> sur sa fiche.</span>';
  }

  /* ---- Bandeau d'etat ---------------------------------------------------- */

  function bindBanner() {
    var banner = document.querySelector('[data-hcx-sf-banner]');
    if (!banner) return;
    var text = banner.querySelector('[data-hcx-sf-banner-text]');
    var editBtn = banner.querySelector('[data-hcx-sf-edit]');
    var clearBtn = banner.querySelector('[data-hcx-sf-clear]');
    var ctx = window.HcxSizeFinderCtx || {};
    var cm = readMeasure();
    var active = activeBuckets();

    function reveal(html, showEdit, info) {
      text.innerHTML = html;
      editBtn.hidden = !showEdit;
      banner.classList.toggle('hcx-sf-banner--info', !!info);
      banner.hidden = false;
    }

    if (gaugeActive()) {
      reveal('Sélection large, par gabarit. Mesurez le tour de poitrail pour affiner.', false, true);
    } else if (active.length) {
      // L'URL est la verite : on n'affiche le centimetre exact que s'il
      // retombe sur la tranche active, jamais une mesure d'un autre filtre.
      var shownCm = trustedCm(cm, active);
      reveal('Filtré pour votre chien : <b>' + (shownCm ? shownCm + ' cm' : active[0]) + '</b>.', true, false);
    } else if (cm && ctx.filterable === false) {
      reveal('Les harnais de cette collection se choisissent au tour de cou, pas au tour de poitrail. '
             + 'Votre mesure de <b>' + cm + ' cm</b> reste enregistrée pour les autres collections.',
             false, true);
    } else if (cm && ctx.filterable) {
      // Mesure en memoire, pas encore appliquee ici. Verrou de session par
      // chemin : interdit toute boucle si la tranche ne renvoie rien.
      var key = 'hcx_sf_applied:' + window.location.pathname;
      var already;
      try { already = sessionStorage.getItem(key); } catch (e) { already = null; }
      if (already !== String(cm)) {
        try { sessionStorage.setItem(key, String(cm)); } catch (e) { /* sans effet */ }
        applyMeasure(cm);
        return;
      }
      // Deja applique une fois sur ce chemin et le filtre n'y est plus : le
      // visiteur l'a retire lui-meme, ou il est revenu sur l'URL nue. Ne rien
      // dire. Annoncer « aucun harnais ne correspond » serait faux, la page
      // affiche le catalogue entier. Le vrai cas sans resultat est traite par
      // bindEmptyState, quand le filtre est reellement actif.
      return;
    } else {
      return;
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        var root = document.querySelector('[data-hcx-sf]');
        if (!root) return;
        var toggle = root.querySelector('[data-hcx-sf-toggle]');
        if (toggle && toggle.offsetParent !== null && !root.classList.contains('is-open')) {
          toggle.click();
        }
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = root.querySelector('[data-hcx-sf-input]');
        if (input) { input.focus(); input.select(); }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearMeasure();
        try { sessionStorage.removeItem('hcx_sf_applied:' + window.location.pathname); } catch (e) {}
        window.location.href = ctx.collectionUrl || '/';
      });
    }
  }

  /* ---- Zero resultat ----------------------------------------------------- */

  function visibleCards() {
    var cards = document.querySelectorAll('.ptq-card');
    var n = 0;
    for (var i = 0; i < cards.length; i++) if (!cards[i].hidden) n++;
    return n;
  }

  function bindEmptyState() {
    var active = activeBuckets();
    if (!active.length) return;
    var cm = trustedCm(readMeasure(), active);
    if (!cm) return; // pas de mesure exacte fiable pour ce filtre : pas de message fabrique
    if (visibleCards() > 0) return;

    var ctx = window.HcxSizeFinderCtx || {};
    var host = document.querySelector('.ptq-container') || document.querySelector('.ptq-section');
    if (!host) return;

    var url = new URL(ctx.catalogueUrl || '/collections/tous-les-harnais-chien', window.location.origin);
    url.searchParams.append(PARAM, bucketFor(cm));

    var box = document.createElement('div');
    box.className = 'hcx-sf-empty';
    box.innerHTML =
      '<p>Aucun harnais de cette collection ne correspond à ' + cm + ' cm.</p>'
      + '<p><a href="' + url.pathname + url.search + '">Voir les harnais à cette taille dans tout le catalogue</a></p>'
      + '<p><button type="button" data-hcx-sf-empty-edit>Modifier la mesure</button></p>';
    host.insertBefore(box, host.firstElementChild);

    var b = box.querySelector('[data-hcx-sf-empty-edit]');
    if (b) {
      b.addEventListener('click', function () {
        var edit = document.querySelector('[data-hcx-sf-edit]');
        if (edit) edit.click();
      });
    }
  }

  /* ---- Collection sans donnee de poitrail -------------------------------- */

  function hideWhereUseless() {
    var ctx = window.HcxSizeFinderCtx || {};
    if (ctx.filterable !== false) return false;
    // Un champ qui appliquerait un filtre inexistant est un cul-de-sac.
    var root = document.querySelector('[data-hcx-sf]');
    if (root) root.hidden = true;
    return true;
  }

  /* ---- Amorcage ---------------------------------------------------------- */

  function boot() {
    if (hideWhereUseless()) { bindBanner(); return; }
    var widgets = document.querySelectorAll('[data-hcx-sf]');
    for (var i = 0; i < widgets.length; i++) bindWidget(widgets[i]);
    bindBanner();
    var badgeCount = paintBadges();
    noteRemoved();
    maybeShowSizeNote(badgeCount);
    bindEmptyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.HcxSizeFinder = {
    bucketFor: bucketFor,
    applyMeasure: applyMeasure,
    readMeasure: readMeasure,
    saveMeasure: saveMeasure,
    clearMeasure: clearMeasure,
    pickSizes: pickSizes,
    MIN_CM: MIN_CM,
    MAX_CM: MAX_CM
  };
})();



